<template>
  <div>
    <el-table
            :data="tableData"
            stripe size="mini"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}"
    >
      <el-table-column :show-overflow-tooltip="true" prop="seqno" align="center" :label="$l('table_hand_serialNumber') || '序号'" width="120">
      </el-table-column>
      <el-table-column prop="deImageUrl" :label="$l('table_hand_image') || '图片'" align="center" width="120">
        <template slot-scope="scope">
          <img fit="cover" :src="scope.row.resImageUrl" style="width: 80px;height: 80px;">
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="sortOrder" align="center" :label="$l('table_hand_sort') || '排序顺序'" width="120">
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="createTime" :label="$l('table_hand_creationTime') || '创建时间'" align="center" width="180">
      </el-table-column>
      <div slot="empty">
        <div class="mt-60">
          <img src="/image/static/img/nodata.png"/>
          <p class="no-data">{{$l('INDEX.tips_no_data')||'暂无数据！'}}</p>
        </div>
      </div>
    </el-table>
    <!--分页-->
    <template>
      <el-pagination
        background
        :current-page="params.curPage"
        :page-size="params.pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="currentChange"
        layout="total, sizes, prev, pager, next, jumper, ->, slot">
      </el-pagination>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    resCode: {
      default: ''
    }
  },
  data () {
    return {
      total: 0,
      params: {
        curPage: 1,
        pageSize: 10,
        resCode: ''
      },
      tableData: []
    }
  },
  methods: {
    init (val) {
      this.params.resCode = val
      this.getData()
    },
    getData () {
      this.$api.researchInfoImageListApi(this.params).then(res => {
        this.total = res.count
        this.params.curPage = res.curPage
        this.params.pageSize = res.pageSize
        this.tableData = res.data
      })
    },
    sizeChange (val) {
      this.params.curPage = 1
      this.params.pageSize = val
      this.getData()
    },
    currentChange (val) {
      this.params.curPage = val
      this.getData()
    }
  }
}
</script>
